import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { AuthShell, AuthInput, PrimaryButton } from "@/components/auth/AuthShell";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. You can sign in now.");
      navigate("/login", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthShell title="Invalid link" subtitle="This password reset link is missing its token.">
        <Link to="/forgot-password" className="font-semibold text-primary hover:underline">Request a new link</Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Choose a new password" subtitle="At least 8 characters with a letter and a number.">
      <form onSubmit={onSubmit} className="space-y-5">
        <AuthInput label="New password" id="password" type="password" data-testid="reset-password-input" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" required minLength={8} autoFocus />
        <AuthInput label="Confirm password" id="confirm" type="password" data-testid="reset-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" required />
        {error && <p className="field-error" role="alert" data-testid="reset-error">{error}</p>}
        <PrimaryButton loading={loading} data-testid="reset-submit-button">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Update password
        </PrimaryButton>
      </form>
    </AuthShell>
  );
}
